import React from 'react'
import { useLocation, NavLink } from 'react-router-dom'
import TypeIt from 'typeit-react'
import HeroImg from '../../assets/img/Hero.png'
import TranslateIcon from '../../assets/icons/Translate.svg'
import { HeroConfig } from '../../constants'

const Home = (props) => {
    const location = useLocation()
    let switchUrl = '/'
    if ( location.pathname === '/' ) {
        switchUrl = '/id'
    }
    let country = props.countryCode
    return (
        <section id="home">
            <div className='flex justify-around items-center w-full h-screen max-h-[600px] px-4 static'>
                <div className="hero-wrapper w-full sm:px-8 sm:w-2/3">
                    <div className="hero-text relative z-40">
                        <div>
                            <div>
                                <h1 className='PT-font-bold font-bold text-4xl text-primary'><TypeIt options={{ 
                                    speed: 75,
                                    loop: true,
                                    loopDelay: 4000,
                                    waitUntilVisible: true
                                }}>Rudin Engineer</TypeIt></h1>
                            </div>
                            <div>
                                <p className='Lato-font mt-1 max-w-[80%] font-medium text-base leading-5 sm:max-w-[75%]'>{ HeroConfig[country].text }</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='sticky hidden sm:flex sm:justify-center sm:items-center sm:w-1/2'>
                    <div className='rounded-full'>
                        <img src={ HeroImg } alt="Rudin Engineer" />
                    </div>
                    {/* <div className='absolute z-[1] rounded-full sm:max-w-[400px] sm:max-h-[400px] md:max-w-[500px] md:max-h-[500px]'>
                        <img src={ HeroImg } alt="Rudin Engineer"/>
                    </div> */}
                    {/* <div className='text-primary flex absolute sm:w-[500px] sm:h-[500px] md:w-[700px] md:h-[700px]'>
                        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                            <path fill="currentColor" d="M52.2,-23.9C57.3,-1.1,44.1,20.7,26.6,32.5C9,44.2,-12.8,46,-30.7,34.8C-48.5,23.6,-62.4,-0.6,-56.6,-24.3C-50.8,-48,-25.4,-71.2,-0.9,-70.9C23.5,-70.6,47,-46.8,52.2,-23.9Z" transform="translate(100 100)" />
                        </svg>
                    </div> */}
                </div>
            </div>
            {/* Particle */}
            <div className="absolute top-0 w-full h-full -z-50 overflow-hidden flex flex-col items-center justify-center">
                <div className="absolute w-full h-full flex flex-col justify-evenly">
                    <div className="particle">
                        <div className="spin bg-primary w-8 h-8 md:w-10 md:h-10"></div>
                    </div>
                    <div className="particle">
                        <div className="bg-primary w-8 h-8 md:w-10 md:h-10 rounded-full"></div>
                    </div>
                    <div className="particle">
                        <div className="spin bg-primary w-8 h-8 md:w-10 md:h-10 rounded-md"></div>
                    </div>
                </div>
                <div className='absolute w-full h-full hidden flex-col justify-between items-end py-6 px-10 sm:flex'>
                    <div className="particle-center-1 w-8 h-8 mt-28 md:w-12 md:h-12">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-moon-fill text-primary w-full h-full" viewBox="0 0 16 16">
                            <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"/>
                        </svg>
                    </div>
                    <div className="particle-center-2 w-8 h-8 rounded-full md:w-12 md:h-12">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart-fill text-primary w-full h-full" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
                        </svg>
                    </div>
                </div>
            </div>
            {/* End Particle */}
            {/* Switch Language */}
            <NavLink to={switchUrl}>
                <div className="switch-language fixed right-2 bottom-2 bg-teal-400 bg-opacity-60 backdrop-blur-sm shaodw-md p-3 rounded-full cursor-pointer z-[9]">
                    <img src={ TranslateIcon } alt="Translate Icon" className='w-4 h-4 cursor-pointer'/>
                </div>
            </NavLink>
            {/* End Switch Language */}
        </section>
    )
}

export default Home